module.exports = __webpack_public_path__ + "img/second-2.416ee699.webp";